export default {
    brand: {},
    header: {},
    footer: {},
};
